const Accordion = ({
    items = []
}) => {
    return (
        <div className="accordion" id="accordionExample">
            {
                items.map(item => (
                    <div className="accordion-item" key={items.indexOf(item)} >
                        <h2 className="accordion-header">
                            <button className={`accordion-button ${item.show ? null : "collapsed"}`} type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${items.indexOf(item)}`} aria-expanded="true" aria-controls={`collapse${items.indexOf(item)}`}>
                                <h3>{item.icon}&nbsp;{item.title}</h3>
                            </button>
                        </h2>
                        <div id={`collapse${items.indexOf(item)}`} className={`accordion-collapse collapse ${item.show ? "show" : null}`} data-bs-parent="#accordionExample">
                            <div className="accordion-body">
                                {item.body}
                            </div>
                        </div>
                    </div>

                ))
            }

        </div>
    )
}

export default Accordion